/**
 * @implements iPermissionStore
 */
export default class PermissionStore
{
    #user;
    #is_initialized = false;
    constructor(user)
    {
      this.#user = user;
    }

    showPermissions()
    {
        if(!this.#is_initialized){
            this.#initPermissions();
        }
        return this.#getGlobalProperties().$store.getters['permissions/permissions'];
    }
    can(key)
    {
        if(!this.#is_initialized){
            this.#initPermissions();
        }
        return this.#getGlobalProperties().$store.getters['permissions/can'](key);
    }
    refreshPrivileges()
    {
        this.#is_initialized = false;
        this.#initPermissions();
    }
    #initPermissions()
    {
        const context = this;

        this.#getGlobalProperties().$resource.users().getPermissions()
            .then(function(response) {
                let permissions = response.data?.data;
                if(!permissions){
                    permissions = [];
                }
                context.#setPermissions(permissions);
                context.#is_initialized = true;

            })
            .catch(err => {
                console.error(err);
                context.#is_initialized = true;
                context.#setPermissions([]);
            });


    }

    #setPermissions(permissions)
    {
        this.#getGlobalProperties().$store.dispatch('permissions/permissions', permissions)
    }
    #getGlobalProperties()
    {
        return this.#user.getGlobalProperties();
    }
}